import { useProducts } from 'src/features/product/product-list/hooks/useProducts';

/**
 * Returns whether the org qualifies as a "first product" org, meaning it has
 * no existing products that are both non-archived and approved.
 * Mirrors the backend check in ProductService.create_product.
 */
export const useIsFirstProduct = () => {
  const { data: products, isLoading, isError } = useProducts();

  const isFirst =
    products != null &&
    !products.some((p) => !p.archived && p.approval_status === 'approved');

  return {
    data: { isFirst },
    isLoading,
    isError
  };
};
